import { View } from "@-/com.npmjs.react-native";
import type { ReactNode } from "react";
import {
  ScrollEdgeTopExtensionContext,
  ScrollEdgeTopInsetContext,
} from "#scroll-edge-top-extension-context";

/**
 * Place this outside navigators: native scenes clip at their own frame, so extending only a
 * nested scroller cannot paint the status area. Floating chrome keeps its clearance inside
 * this full-height viewport; opaque chrome retains a spacer above its scenes.
 */
export function ScrollEdgeViewport({
  children,
  edgeToEdge,
  topInset,
}: {
  children: ReactNode;
  edgeToEdge: boolean;
  topInset: number;
}) {
  const paddingTop = edgeToEdge ? 0 : topInset;
  return (
    <View className="flex-1" style={{ paddingTop }}>
      <ScrollEdgeTopExtensionContext value={edgeToEdge ? 0 : topInset}>
        <ScrollEdgeTopInsetContext value={edgeToEdge ? topInset : 0}>
          {children}
        </ScrollEdgeTopInsetContext>
      </ScrollEdgeTopExtensionContext>
    </View>
  );
}
